<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10p6OC6/tc-custom/9780253026897.jpg?1717895967882" alt="This image is the cover for the book Ferruccio Busoni and His Legacy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ferruccio Busoni and His Legacy
      </h1>
      <p class="bookDescription body article font2">
        <b>An analysis of the composer’s unconventional teaching style and philosophy, his relationship with his students, and his effect on twentieth century music.</b><br/><br/>Many students of renowned composer, conductor, and teacher Ferruccio Busoni had illustrious careers of their own, yet the extent to which their mentor’s influence helped shape their success was largely unexplored until now. Through rich archival research including correspondence, essays, and scores, Erinn E. Knyt presents an evocative account of Busoni’s idiosyncratic pedagogy—focused on aesthetic ideals rather than methodologies or techniques—and how this teaching style and philosophy can be seen and heard in the Nordic-inspired musical works of Sibelius, the unusual soundscapes of Varèse, the polystylistic meldings of music and technology in Louis Gruenberg’s radio operas and film scores, the electronic music of Otto Luening, and the experimentalism of Philip Jarnach. Equal parts critical biography and interpretive analysis, Knyt’s work compels a reconsideration of Busoni’s legacy and puts forth the notion of a “Busoni School” as one that shaped the trajectory of twentieth-century music.<br/><br/><b>“Erinn Knyt’s <i>Ferruccio Busoni and His Legacy </i>is a most welcome addition to the literature on Busoni as a fine example of research based on primary sources.” —<i>Bach</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Erinn E. Knyt
      </h2>
      
      <p class="authorDescription body article"><P>Erinn E. Knyt is Assistant Professor of Music History at the University of Massachusetts, Amherst. Knyt specializes in 19th- and 20th-century music, aesthetics, and performance studies and has written extensively about Ferruccio Busoni. She has articles in the Journal of the Royal Musical Association, the Journal of Musicological Research, American Music, the Journal of Musicology, the Journal of Music History Pedagogy, and Twentieth Century Music.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?99125e66